<!--
 * @Author: cmchiu
 * @Date: 2022-09-02 17:58:57
 * @LastEditTime: 2023-02-08 17:52:27
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \LearningMarket2\LearningMarket-ClientApp\src\views\CourseList.vue
 * 
-->
<template>
    <div class="course-list">
        <!-- 課程搜尋列 -->
        <div
            class="row"
            v-loading.fullscreen.lock="configs.loading"
            element-loading-text="加載中，請稍候..."
            element-loading-background="rgba(255, 255, 255, 0.5)"
        >
            <div class="col-lg-6 col-md-8 col-12 class_select">
                <el-link :underline="false" :class="courseLs.filter.days != 0 ? '' : 'active'" @click="daysChange(0)">
                    全部課程
                </el-link>
                <el-link :underline="false" :class="courseLs.filter.days != 14 ? '' : 'active'" @click="daysChange(14)">
                    兩週內課程
                </el-link>
                |
                <el-link
                    :underline="false"
                    class="act-type"
                    :class="courseLs.filter.actType == null ? 'active' : ''"
                    @click="courseTypeChange(null)"
                >
                    »全部類型
                </el-link>
                <el-link
                    :underline="false"
                    class="act-type"
                    :class="courseLs.filter.actType == 10 ? 'active' : ''"
                    @click="courseTypeChange(10)"
                >
                    »實體課程
                </el-link>
                <el-link
                    :underline="false"
                    class="act-type"
                    :class="courseLs.filter.actType == 20 ? 'active' : ''"
                    @click="courseTypeChange(20)"
                >
                    »線上課程
                </el-link>
            </div>

            <div class="col-lg-6 col-md-4 col-12 text-right">
                <el-tooltip
                    content="點擊「放大鏡」圖示以搜尋課程"
                    effect="dark"
                    placement="right-end"
                    :open-delay="500"
                >
                    <div class="search-box" style="float: right">
                        <button class="btn-search" @click="daysChange()">
                            <i class="fas fa-search"></i>
                        </button>

                        <input
                            ref="keywordSearch"
                            type="text"
                            class="input-search input-search-click"
                            v-model.trim="courseLs.filter.keyword"
                            :disabled="configs.loading"
                            @blur="daysChange()"
                            @keyup.enter.native="daysChange()"
                            placeholder="搜尋"
                        />
                    </div>
                </el-tooltip>
            </div>
        </div>

        <!-- 課程列表 -->
        <div class="row" v-if="courseLs.data.length > 0">
            <div class="col-lg-4 col-md-6 col-sm-6 col-12" v-for="item in courseLs.data" :key="item.LMIT_ID">
                <div class="card LM_card">
                    <router-link :to="`/coursebook?id=${item.LMIT_ID}`">
                        <div class="card-body">
                            <div class="state_tag">
                                <img
                                    src="assets/images/learningmarket/hot.png"
                                    alt="hot"
                                    v-if="item.LMIT_HotStatus === '1'"
                                />
                                <img
                                    src="assets/images/learningmarket/new.png"
                                    alt="new"
                                    v-if="item.LMIT_HotStatus === '2'"
                                />
                            </div>
                            <p
                                class="card-title"
                                :class="
                                    item.LMAT_Class === '1001'
                                        ? 'card_language' // 語文學習
                                        : item.LMAT_Class === '1002'
                                        ? 'card_tech' // 資訊科技
                                        : item.LMAT_Class === '1003'
                                        ? 'card_method' // 學習方法
                                        : item.LMAT_Class === '1004'
                                        ? 'card_basic' // 基礎科目輔導課
                                        : item.LMAT_Class === '1005'
                                        ? 'card_heart' // 心靈成長
                                        : item.LMAT_Class === '1006'
                                        ? 'card_paper' // 論文達人
                                        : item.LMAT_Class === '1007'
                                        ? 'card_career' // 職涯活動
                                        : item.LMAT_Class === '1010'
                                        ? 'card_workshop' // 校園活動(講座)
                                        : item.LMAT_Class === '1011'
                                        ? 'card_student' // 學生講師
                                        : item.LMAT_Class === '1012'
                                        ? 'card_meeting' // 教師請益時間
                                        : ''
                                "
                            >
                                {{ item.LMAT_ClassName }}
                            </p>

                            <p class="card-text card_class">{{ item.LMIT_Name_1000 }}</p>

                            <div class="card-text card_teacher">{{ item.LMIT_Lecturer }}</div>
                            <div class="card-text card_room">{{ item.LMIT_Place }}</div>
                            <div class="card-text card_year">{{ item.LMIT_STime.substr(0, 4) }}</div>
                            <div class="card-text">
                                <span class="card_date">{{ item.LMIT_STime.substr(5, 5).replace('-', '/') }}</span>
                                <span class="card_time">
                                    {{ item.LMIT_STime.substr(11, 5) }}
                                    <span class="card_time_icon">
                                        <img src="assets/images/learningmarket/time.png" alt="time" />
                                    </span>
                                    {{ item.LMIT_ETime.substr(11, 5) }}
                                </span>
                            </div>
                        </div>

                        <img
                            src="assets/images/learningmarket/language.jpg"
                            class="card-img-top"
                            alt="language"
                            v-if="item.LMAT_Class === '1001'"
                        />
                        <img
                            src="assets/images/learningmarket/tech.jpg"
                            class="card-img-top"
                            alt="tech"
                            v-if="item.LMAT_Class === '1002'"
                        />
                        <img
                            src="assets/images/learningmarket/method.jpg"
                            class="card-img-top"
                            alt="method"
                            v-if="item.LMAT_Class === '1003'"
                        />
                        <img
                            src="assets/images/learningmarket/basic.jpg"
                            class="card-img-top"
                            alt="basic"
                            v-if="item.LMAT_Class === '1004'"
                        />
                        <img
                            src="assets/images/learningmarket/heart.jpg"
                            class="card-img-top"
                            alt="heart"
                            v-if="item.LMAT_Class === '1005'"
                        />
                        <img
                            src="assets/images/learningmarket/paper.jpg"
                            class="card-img-top"
                            alt="paper"
                            v-if="item.LMAT_Class === '1006'"
                        />
                        <img
                            src="assets/images/learningmarket/career.jpg"
                            class="card-img-top"
                            alt="career"
                            v-if="item.LMAT_Class === '1007'"
                        />
                        <img
                            src="assets/images/learningmarket/workshop.jpg"
                            class="card-img-top"
                            alt="workshop"
                            v-if="item.LMAT_Class === '1010'"
                        />
                        <img
                            src="assets/images/learningmarket/student.jpg"
                            class="card-img-top"
                            alt="student"
                            v-if="item.LMAT_Class === '1011'"
                        />
                        <img
                            src="assets/images/learningmarket/meeting.jpg"
                            class="card-img-top"
                            alt="meeting"
                            v-if="item.LMAT_Class === '1012'"
                        />

                        <div class="card-footer card_state" v-if="item.balance > 0">
                            <div>尚餘{{ item.balance }}人</div>
                        </div>
                        <div class="card-footer card_state02" v-else>
                            <div>已額滿</div>
                        </div>
                    </router-link>
                </div>
            </div>

            <div class="go-next">
                <el-button
                    class="btnGoNext"
                    @click="nextPages"
                    v-if="courseLs.pages.pageCurrent * courseLs.pages.pageSize + 1 <= courseLs.pages.totalResult"
                >
                    {{ `點擊查看下${courseLs.pages.pageSize}堂課程` }}
                </el-button>
                <el-button class="btnGoNext is-disabled" disabled v-else> 已經沒有更多的課程了 </el-button>
            </div>
        </div>
        <!-- 課程列表(空值) -->
        <div class="row mt-3" v-else>
            <div class="col-lg-12 class_null text-center">
                <img src="assets/images/learningmarket/null.png" alt="" />
                <p>目前暫無相關課程</p>
                <div class="text-center mt-3">
                    <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal" class="green_btn02">
                        填寫開課需求調查
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import course from '@/api/course'

export default {
    name: 'CourseList',

    data: function () {
        return {
            configs: {
                loading: false,
            },
            courseClass: [],
            courseLs: {
                filter: {
                    days: 14,
                    courseClass: null,
                    keyword: '',
                    actType: null,
                },
                data: [],
                pages: {
                    totalResult: 0, // 總筆數
                    pageSize: 15, // 分頁大小
                    pageCurrent: 1, // 目前頁次
                },
            },
        }
    },

    created: function () {
        this.getCourseList()
    },

    mounted: function () {},

    watch: {
        '$store.getters.reload': function (newVal, oldVal) {
            if (!XEUtils.isEqual(newVal, oldVal)) {
                this.getCourseList(true)
            }
        },
    },

    methods: {
        async getCourseList(reset) {
            const vm = this
            if (typeof reset === 'boolean' && reset) {
                vm.courseLs.data = []
                vm.courseLs.pages.totalResult = 0
                vm.courseLs.pages.pageCurrent = 1
            }
            if (vm.$route.query.class) vm.courseLs.filter.days = 0 //如果選擇類別, 則將取全部課程
            vm.configs.loading = true
            let params = {
                Days: vm.courseLs.filter.days,
                CourseClass: vm.$route.query.class, //vm.courseLs.filter.courseClass,
                Keyword: vm.courseLs.filter.keyword,
                ActType: vm.courseLs.filter.actType,
                PageSize: vm.courseLs.pages.pageSize,
                PageCurrent: vm.courseLs.pages.pageCurrent,
            }
            await course
                .getCourseList(params)
                .then(res => {
                    if (res.Code === 1) {
                        // vm.courseLs.data = res.Items
                        XEUtils.arrayEach(res.Items, item => {
                            vm.courseLs.data.push(item)
                        })
                        vm.courseLs.pages.totalResult = res.TotalResult
                        // vm.$message({
                        //     message: res.Msg,
                        //     type: 'success',
                        // })
                    } else {
                        vm.courseLs.data = []
                        vm.courseLs.pages.totalResult = 0
                    }
                })
                .then(() => {
                    vm.configs.loading = false
                })
        },

        daysChange(days) {
            const vm = this
            if (typeof days === 'number') vm.courseLs.filter.days = days
            vm.getCourseList(true)
        },

        courseTypeChange(actType) {
            const vm = this
            vm.courseLs.filter.actType = actType
            vm.getCourseList(true)
        },

        nextPages() {
            let page = this.courseLs.pages
            if (page.pageCurrent * page.pageSize + 1 <= page.totalResult) {
                page.pageCurrent++
                this.getCourseList()
            }
        },
    },
}
</script>

<style scoped lang="scss">
:deep .el-pagination {
    button {
        width: auto;
    }
}
:deep .vxe-table {
    .tb-header {
        color: black;
        background-color: #dcdcdc;
    }
}
:deep .vxe-pager {
    button {
        width: auto;
    }
}
.class_select a {
    padding: 0 5px;
}
.el-link.el-link--default.active {
    font-weight: bold;
}
.act-type.el-link.el-link--default {
    color: #298081;
}
.act-type.el-link.el-link--default.active {
    color: #298081;
    background-color: #e3f0f0;
    border: none;
    font-weight: bold;
}
.go-next {
    padding-top: 2rem;
    text-align: center;

    :deep .btnGoNext {
        width: 18rem;
        height: 42px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #2d9698;
        color: #fff;
    }
    :deep .btnGoNext:hover {
        width: 18rem;
        height: 42px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #37b4b6;
        color: #fff;
    }
    :deep .btnGoNext.is-disabled {
        width: 18rem;
        height: 42px;
        font-size: 20px;
        padding: 5px 50px;
        border-radius: 25px;
        background-color: #ccc;
        color: #fff;
    }
}
</style>
